const o={Dropdown:1e3,Fixed:1030,Modal:1060,ModalBackdrop:1050,OffCanvas:1040,PopOver:1070,Sticky:1020,ToolTip:1080};export{o as ZIndex};
